import styled, { css } from 'styled-components'

export const CouponWrapperUi = styled.div`
  padding: 10px;

  ${p => p.theme.phone} {
    padding: 5px;
  }
  ${p =>
    p.theme.isEditorMobileMode &&
    css`
      padding: 5px;
    `}
`
